import axios from "axios";
import dayjs from "dayjs";
import { useFormik } from "formik";
import { values } from "lodash";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { API } from "../../helpers/constants";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../helpers/errorHandling";
import { CHECKLISTS } from "../../locales/pages/namespaces";
import useUserAction from "../user/useUserAction";
import useUserData from "../user/useUserData";

const useCheckListsForm = ({ checkList }) => {
	const { t } = useTranslation(CHECKLISTS)
	const { token, username, userId, isLoggedIn, dateFormat, timeFormat } = useUserData()
	const { userLogout } = useUserAction()
	const [loadingSubmit, setLoadingSubmit] = useState(false)
	
	const onSubmit = (values) => {
		setLoadingSubmit(true)
		axios({
			method: 'post',
			headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}` },
			data: {
				"ucSignName": values.signName,
				"ucDailyTasks": values.ucDailyTasks,
				"ucDailyComment": values.ucDailyComment,
				"ucWeeklyTasks": values.ucWeeklyTasks,
				"ucWeeklyComment": values.ucWeeklyComment,
				"ucMonthlyTasks": values.ucMonthlyTasks,
				"ucMonthlyComment": values.ucMonthlyComment ,
				"ucTrimesterTasks": values.ucTrimesterTasks ,
				"ucTrimesterComment": values.ucTrimesterComment,
				"ucMonthlyTasks2": values.ucMonthlyTasks2 ,
				"ucMonthlyComment2": values.ucMonthlyComment2 ,
				"ucTrimesterTasks2": values.ucTrimesterTasks2 ,
				"ucTrimesterComment2": values.ucTrimesterComment2 ,
				"ucYearlyTask": values.ucYearlyTask ,
				"ucYearlyComment": values.ucYearlyComment ,
				"ucYearlyTask2": values.ucYearlyTask2 ,
				"ucYearlyComment2": values.ucYearlyComment2 ,
				// "binTasks": values.binTasks,
				// "binComment": values.binComment,
				// "wasteCollection": values.wasteCollection,
				// "wasteCollectionComment": values.wasteCollectionComment ,
				// "furniture": values.furniture,
				// "furnitureComment": values.furnitureComment,
				// "bowlsAndLids": values.bowlsAndLids,
				// "bowlsAndLidsComment": values.bowlsAndLidsComment,
				// "sweepTheFloor": values.sweepTheFloor,
				// "sweepTheFloorComment": values.sweepTheFloorComment,
				// "mopTheFloor": values.mopTheFloor,
				// "mopTheFloorComment": values.mopTheFloorComment,
				// "toiletPaper": values.toiletPaper,
				// "toiletPaperComment": values.toiletPaperComment,
				// "cleanTheSinks": values.cleanTheSinks,
				// "cleanTheSinksComment": values.cleanTheSinksComment,
				// "cleanHandDryers": values.cleanHandDryers,
				// "cleanHandDryersComment": values.cleanHandDryersComment,
				// "washTheCups": values.washTheCups,
				// "washTheCupsComment": values.washTheCupsComment,
				// "sweepTheSidewalk": values.sweepTheSidewalk,
				// "sweepTheSidewalkComment": values.sweepTheSidewalkComment,
				// "sweepElevators": values.sweepElevators,
				// "sweepElevatorsComment": values.sweepElevatorsComment,
				// "sweepFloorsWithVacuumCleaner": values.sweepFloorsWithVacuumCleaner,
				// "sweepFloorsWithVacuumCleanerComment": values.sweepFloorsWithVacuumCleanerComment,
				// "vacuumCarpetedAreas": values.vacuumCarpetedAreas,
				// "vacuumCarpetedAreasComment": values.vacuumCarpetedAreasComment,
				// "cleanFloorsWithSpecialLiquid": values.cleanFloorsWithSpecialLiquid,
				// "cleanFloorsWithSpecialLiquidComment": values.cleanFloorsWithSpecialLiquidComment,
				// "dustTheFolders": values.dustTheFolders,
				// "dustTheFoldersComment": values.dustTheFoldersComment,
				// "cleanThePhones": values.cleanThePhones,
				// "cleanThePhonesComment": values.cleanThePhonesComment,
				// "dustBookcases": values.dustBookcases,
				// "dustBookcasesComment": values.dustBookcasesComment,
				// "cleanMetals": values.cleanMetals,
				// "cleanMetalsComment": values.cleanMetalsComment,
				// "cleanEntranceDoors": values.cleanEntranceDoors,
				// "cleanEntranceDoorsComment": values.cleanEntranceDoorsComment,
				// "cleanFingerPrints": values.cleanFingerPrints,
				// "cleanFingerPrintsComment": values.cleanFingerPrintsComment,
				// "dustPlantPots": values.dustPlantPots,
				// "dustPlantPotsComment": values.dustPlantPotsComment,
				// "dustWindowSills": values.dustWindowSills,
				// "dustWindowSillsComment": values.dustWindowSillsComment,
				// "sweepAndMopStairs": values.sweepAndMopStairs,
				// "sweepAndMopStairsComment": values.sweepAndMopStairsComment,
				// "glassOfBookcasesDay1": values.glassOfBookcasesDay1 ? dayjs(values.glassOfBookcasesDay1).format('YYYY-MM-DD') : null,
				// "glassOfBookcasesDay2": values.glassOfBookcasesDay2 ? dayjs(values.glassOfBookcasesDay2).format('YYYY-MM-DD') : null,
				// "glassOfBookcasesDay3": values.glassOfBookcasesDay3 ? dayjs(values.glassOfBookcasesDay3).format('YYYY-MM-DD') : null,
				// "glassOfBookcasesDay4": values.glassOfBookcasesDay4 ? dayjs(values.glassOfBookcasesDay4).format('YYYY-MM-DD') : null,
				// "glassOfBookcasesComment": values.glassOfBookcasesComment,
				// "glossyFurnitureDay1": values.glossyFurnitureDay1 ? dayjs(values.glossyFurnitureDay1).format('YYYY-MM-DD') : null,
				// "glossyFurnitureDay2": values.glossyFurnitureDay2 ? dayjs(values.glossyFurnitureDay2).format('YYYY-MM-DD') : null,
				// "glossyFurnitureDay3": values.glossyFurnitureDay3 ? dayjs(values.glossyFurnitureDay3).format('YYYY-MM-DD') : null,
				// "glossyFurnitureDay4": values.glossyFurnitureDay4 ? dayjs(values.glossyFurnitureDay4).format('YYYY-MM-DD') : null,
				// "glossyFurnitureComment": values.glossyFurnitureComment,
				// "toiletWallsDay1": values.toiletWallsDay1 ?dayjs(values.toiletWallsDay1).format('YYYY-MM-DD') : null,
				// "toiletWallsDay2": values.toiletWallsDay2 ? dayjs(values.toiletWallsDay2).format('YYYY-MM-DD') : null,
				// "toiletWallsDay3": values.toiletWallsDay3 ?dayjs(values.toiletWallsDay3).format('YYYY-MM-DD') : null,
				// "toiletWallsDay4": values.toiletWallsDay4 ?dayjs(values.toiletWallsDay4).format('YYYY-MM-DD') : null,
				// "toiletWallsComment": values.toiletWallsComment,
				// "cleanPhotocopiersDay1": values.cleanPhotocopiersDay1 ? dayjs(values.cleanPhotocopiersDay1).format('YYYY-MM-DD') : null,
				// "cleanPhotocopiersDay2": values.cleanPhotocopiersDay2 ?  dayjs(values.cleanPhotocopiersDay2).format('YYYY-MM-DD') : null,
				// "cleanPhotocopiersDay3": values.cleanPhotocopiersDay3 ? dayjs(values.cleanPhotocopiersDay3).format('YYYY-MM-DD') : null,
				// "cleanPhotocopiersDay4": values.cleanPhotocopiersDay4 ? dayjs(values.cleanPhotocopiersDay4).format('YYYY-MM-DD') : null,
				// "cleanPhotocopiersComment": values.cleanPhotocopiersComment,
				// "cleanSurroundingBuildDay1": values.cleanSurroundingBuildDay1 ? dayjs(values.cleanSurroundingBuildDay1).format('YYYY-MM-DD') : null,
				// "cleanSurroundingBuildDay2": values.cleanSurroundingBuildDay2 ? dayjs(values.cleanSurroundingBuildDay2).format('YYYY-MM-DD') : null,
				// "cleanSurroundingBuildDay3": values.cleanSurroundingBuildDay3 ? dayjs(values.cleanSurroundingBuildDay3).format('YYYY-MM-DD') : null,
				// "cleanSurroundingBuildDay4": values.cleanSurroundingBuildDay4 ? dayjs(values.cleanSurroundingBuildDay4).format('YYYY-MM-DD') : null,
				// "cleanSurroundingBuildComment": values.cleanSurroundingBuildComment,
				// "dustCabinetsDate": values.dustCabinetsDate ? dayjs(values.dustCabinetsDate).format('YYYY-MM-DD') : null,
				// "dustCabinetsComment": values.dustCabinetsComment,
				// "wasteBasketsDate": values.wasteBasketsDate ? dayjs(values.wasteBasketsDate).format('YYYY-MM-DD') : null,
				// "wasteBasketsComment": values.wasteBasketsComment,
				// "movedFurnitureDate":values.movedFurnitureDate ? dayjs(values.movedFurnitureDate).format('YYYY-MM-DD') : null,
				// "movedFurnitureComment": values.movedFurnitureComment,
				// "vacuumFurnitureDate": values.vacuumFurnitureDate ? dayjs(values.vacuumFurnitureDate).format('YYYY-MM-DD') : null,
				// "vacuumFurnitureComment": values.vacuumFurnitureComment,
				// "windowBlindsDate": values.windowBlindsDate ? dayjs(values.windowBlindsDate).format('YYYY-MM-DD') : null,
				// "windowBlindsComment": values.windowBlindsComment,
				// "auxiliaryAreasDate": values.auxiliaryAreasDate ? dayjs(values.auxiliaryAreasDate).format('YYYY-MM-DD') : null,
				// "auxiliaryAreasComment": values.auxiliaryAreasComment,
				// "glassFacadesDate": values.glassFacadesDate ? dayjs(values.glassFacadesDate).format('YYYY-MM-DD') : null,
				// "glassFacadesComment": values.glassFacadesComment,
				// "wipeRoofsDate": values.wipeRoofsDate ? dayjs(values.wipeRoofsDate).format('YYYY-MM-DD') : null,
				// "wipeRoofsComment": values.wipeRoofsComment,
				// "multiStoreyDate": values.multiStoreyDate ? dayjs(values.multiStoreyDate).format('YYYY-MM-DD') : null,
				// "multiStoreyComment": values.multiStoreyComment,
				// "securityShuttersDate": values.securityShuttersDate ? dayjs(values.securityShuttersDate).format('YYYY-MM-DD') : null,
				// "securityShuttersComment": values.securityShuttersComment,
				// "officeCarpetsDate": values.officeCarpetsDate ? dayjs(values.officeCarpetsDate).format('YYYY-MM-DD') : null,
				// "officeCarpetsComment": values.officeCarpetsComment,
				// "kitchenCabinetsDate": values.kitchenCabinetsDate ? dayjs(values.kitchenCabinetsDate).format('YYYY-MM-DD') : null,
				// "kitchenCabinetsComment": values.kitchenCabinetsComment,
				// "externalMarbleDate": values.externalMarbleDate ? dayjs(values.externalMarbleDate).format('YYYY-MM-DD') : null,
				// "externalMarbleComment": values.externalMarbleComment,
				// "marbleFloorsDate": values.marbleFloorsDate ? dayjs(values.marbleFloorsDate).format('YYYY-MM-DD') : null,
				// "marbleFloorsComment": values.marbleFloorsComment,
				// "washGlassDate": values.washGlassDate ? dayjs(values.washGlassDate).format('YYYY-MM-DD') : null,
				// "washGlassComment": values.washGlassComment,
				// "specialMultiStoreyDate": values.specialMultiStoreyDate ? dayjs(values.specialMultiStoreyDate).format('YYYY-MM-DD') : null,
				// "specialMultiStoreyComment": values.specialMultiStoreyComment,
				// "washSecurityShuttersDate": values.washSecurityShuttersDate ? dayjs(values.washSecurityShuttersDate).format('YYYY-MM-DD') : null,
				// "washSecurityShuttersComment": values.washSecurityShuttersComment,
				// "washOfficeCarpetsDate": values.washOfficeCarpetsDate ? dayjs(values.washOfficeCarpetsDate).format('YYYY-MM-DD') : null,
				// "washOfficeCarpetsComment": values.washOfficeCarpetsComment,
				// "washSeatsDate": values.washSeatsDate ? dayjs(values.washSeatsDate).format('YYYY-MM-DD') : null,
				// "washSeatsComment": values.washSeatsComment,
				// "mechanicalWashingDate": values.mechanicalWashingDate ? dayjs(values.mechanicalWashingDate).format('YYYY-MM-DD') : null,
				// "mechanicalWashingComment": values.mechanicalWashingComment,
			},
			url: `${API}/en/custom/goodtohave/update/${checkList.id}`
		}).then(response => {
			setLoadingSubmit(false)
			enqueueSnackbar(t('The form was successfully submitted!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
		}).catch((error) => {
			setLoadingSubmit(false)
			const errorMessage = `${t('An error occurred!')} ${error?.response?.data?.errors}`;
			enqueueSnackbar(handleAxiosErrors(error, errorMessage), {
				variant: 'error',
				autoHideDuration: 3000,
			})
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}
	
	const validationSchema = yup.object().shape({
		// glassOfBookcasesDay1: yup.string().required(t('Required')),
		// glassOfBookcasesDay2: yup.string().required(t('Required')),
		// glassOfBookcasesDay3: yup.string().required(t('Required')),
		// glassOfBookcasesDay4: yup.string().required(t('Required')),
		// glossyFurnitureDay1: yup.string().required(t('Required')),
		// glossyFurnitureDay2: yup.string().required(t('Required')),
		// glossyFurnitureDay3: yup.string().required(t('Required')),
		// glossyFurnitureDay4: yup.string().required(t('Required')),
		// toiletWallsDay1: yup.string().required(t('Required')),
		// toiletWallsDay2: yup.string().required(t('Required')),
		// toiletWallsDay3: yup.string().required(t('Required')),
		// toiletWallsDay4: yup.string().required(t('Required')),
		// cleanPhotocopiersDay1: yup.string().required(t('Required')),
		// cleanPhotocopiersDay2: yup.string().required(t('Required')),
		// cleanPhotocopiersDay3: yup.string().required(t('Required')),
		// cleanPhotocopiersDay4: yup.string().required(t('Required')),
		// cleanSurroundingBuildDay1: yup.string().required(t('Required')),
		// cleanSurroundingBuildDay2: yup.string().required(t('Required')),
		// cleanSurroundingBuildDay3: yup.string().required(t('Required')),
		// cleanSurroundingBuildDay4: yup.string().required(t('Required')),
		// dustCabinetsDate: yup.string().required(t('Required')),
		// wasteBasketsDate: yup.string().required(t('Required')),
		// movedFurnitureDate: yup.string().required(t('Required')),
		// vacuumFurnitureDate: yup.string().required(t('Required')),
		// windowBlindsDate: yup.string().required(t('Required')),
		// auxiliaryAreasDate: yup.string().required(t('Required')),
		// glassFacadesDate: yup.string().required(t('Required')),
		// wipeRoofsDate: yup.string().required(t('Required')),
		// multiStoreyDate: yup.string().required(t('Required')),
		// securityShuttersDate: yup.string().required(t('Required')),
		// officeCarpetsDate: yup.string().required(t('Required')),
		// kitchenCabinetsDate: yup.string().required(t('Required')),
		// externalMarbleDate: yup.string().required(t('Required')),
		// marbleFloorsDate: yup.string().required(t('Required')),
		// washGlassDate: yup.string().required(t('Required')),
		// specialMultiStoreyDate: yup.string().required(t('Required')),
		// washSecurityShuttersDate: yup.string().required(t('Required')),
		// washOfficeCarpetsDate: yup.string().required(t('Required')),
		// washSeatsDate: yup.string().required(t('Required')),
		// mechanicalWashingDate: yup.string().required(t('Required')),
		signName: yup.string().required(t('Required')),
		
	})
	console.log(checkList)
	const formik = useFormik({
		initialValues: {
			activeFromDt: checkList?.activeFromDt,
			activeToDt: checkList?.activeToDt,
			
			// binTasks: checkList?.binTasks,
			// binComment: checkList?.binComment,
			// wasteCollection: checkList?.wasteCollection,
			// wasteCollectionComment: checkList?.wasteCollectionComment,
			// furniture: checkList?.furniture,
			// furnitureComment: checkList?.furnitureComment,
			// bowlsAndLids: checkList?.bowlsAndLids,
			// bowlsAndLidsComment: checkList?.bowlsAndLidsComment,
			// sweepTheFloor: checkList?.sweepTheFloor,
			// sweepTheFloorComment: checkList?.sweepTheFloorComment,
			// mopTheFloor: checkList?.mopTheFloor,
			// mopTheFloorComment: checkList?.mopTheFloorComment,
			// toiletPaper: checkList?.toiletPaper,
			// toiletPaperComment: checkList?.toiletPaperComment,
			// cleanTheSinks: checkList?.cleanTheSinks,
			// cleanTheSinksComment: checkList?.cleanTheSinksComment,
			// cleanHandDryers: checkList?.cleanHandDryers,
			// cleanHandDryersComment: checkList?.cleanHandDryersComment,
			// washTheCups: checkList?.washTheCups,
			// washTheCupsComment: checkList?.washTheCupsComment,
			// sweepTheSidewalk: checkList?.sweepTheSidewalk,
			// sweepTheSidewalkComment: checkList?.sweepTheSidewalkComment,
			// sweepElevators: checkList?.sweepElevators,
			// sweepElevatorsComment: checkList?.sweepElevatorsComment,
			// sweepFloorsWithVacuumCleaner: checkList?.sweepFloorsWithVacuumCleaner,
			// sweepFloorsWithVacuumCleanerComment: checkList?.sweepFloorsWithVacuumCleanerComment,
			// vacuumCarpetedAreas: checkList?.vacuumCarpetedAreas,
			// vacuumCarpetedAreasComment: checkList?.vacuumCarpetedAreasComment,
			// cleanFloorsWithSpecialLiquid: checkList?.cleanFloorsWithSpecialLiquid,
			// cleanFloorsWithSpecialLiquidComment: checkList?.cleanFloorsWithSpecialLiquidComment,
			// dustTheFolders: checkList?.dustTheFolders,
			// dustTheFoldersComment: checkList?.dustTheFoldersComment,
			// cleanThePhones: checkList?.cleanThePhones,
			// cleanThePhonesComment: checkList?.cleanThePhonesComment,
			// dustBookcases: checkList?.dustBookcases,
			// dustBookcasesComment: checkList?.dustBookcasesComment,
			// cleanMetals: checkList?.cleanMetals,
			// cleanMetalsComment: checkList?.cleanMetalsComment,
			// cleanEntranceDoors: checkList?.cleanEntranceDoors,
			// cleanEntranceDoorsComment: checkList?.cleanEntranceDoorsComment,
			// cleanFingerPrints: checkList?.cleanFingerPrints,
			// cleanFingerPrintsComment: checkList?.cleanFingerPrintsComment,
			// dustPlantPots: checkList?.dustPlantPots,
			// dustPlantPotsComment: checkList?.dustPlantPotsComment,
			// dustWindowSills: checkList?.dustWindowSills,
			// dustWindowSillsComment: checkList?.dustWindowSillsComment,
			// sweepAndMopStairs: checkList?.sweepAndMopStairs,
			// sweepAndMopStairsComment: checkList?.sweepAndMopStairsComment,
			// glassOfBookcasesDay1: checkList?.glassOfBookcasesDay1 ? dayjs(checkList.glassOfBookcasesDay1) : null,
			// glassOfBookcasesDay2: checkList?.glassOfBookcasesDay2 ? dayjs(checkList.glassOfBookcasesDay2) : null,
			// glassOfBookcasesDay3: checkList?.glassOfBookcasesDay3 ? dayjs(checkList.glassOfBookcasesDay3) : null,
			// glassOfBookcasesDay4: checkList?.glassOfBookcasesDay4 ? dayjs(checkList.glassOfBookcasesDay4) : null,
			// glassOfBookcasesComment: checkList?.glassOfBookcasesComment,
			// glossyFurnitureDay1: checkList?.glossyFurnitureDay1 ? dayjs(checkList.glossyFurnitureDay1) : null,
			// glossyFurnitureDay2: checkList?.glossyFurnitureDay2 ? dayjs(checkList.glossyFurnitureDay2) : null,
			// glossyFurnitureDay3: checkList?.glossyFurnitureDay3 ? dayjs(checkList.glossyFurnitureDay3) : null,
			// glossyFurnitureDay4 : checkList?.glossyFurnitureDay4 ? dayjs(checkList.glossyFurnitureDay4) : null,
			// glossyFurnitureComment:  checkList?.glossyFurnitureComment,
			// toiletWallsDay1: checkList?.toiletWallsDay1 ? dayjs(checkList.toiletWallsDay1) : null,
			// toiletWallsDay2: checkList?.toiletWallsDay2 ? dayjs(checkList.toiletWallsDay2) : null,
			// toiletWallsDay3: checkList?.toiletWallsDay3 ? dayjs(checkList.toiletWallsDay3) : null,
			// toiletWallsDay4: checkList?.toiletWallsDay4 ? dayjs(checkList.toiletWallsDay4) : null,
			// toiletWallsComment: checkList?.toiletWallsComment,
			// cleanPhotocopiersDay1: checkList?.cleanPhotocopiersDay1 ? dayjs(checkList.cleanPhotocopiersDay1) : null,
			// cleanPhotocopiersDay2: checkList?.cleanPhotocopiersDay2 ? dayjs(checkList.cleanPhotocopiersDay2) : null,
			// cleanPhotocopiersDay3: checkList?.cleanPhotocopiersDay3 ? dayjs(checkList.cleanPhotocopiersDay3) : null,
			// cleanPhotocopiersDay4: checkList?.cleanPhotocopiersDay4 ? dayjs(checkList.cleanPhotocopiersDay4) : null,
			// cleanPhotocopiersComment: checkList?.cleanPhotocopiersComment,
			// cleanSurroundingBuildDay1: checkList?.cleanSurroundingBuildDay1 ? dayjs(checkList.cleanSurroundingBuildDay1) : null,
			// cleanSurroundingBuildDay2: checkList?.cleanSurroundingBuildDay2 ? dayjs(checkList.cleanSurroundingBuildDay2) : null,
			// cleanSurroundingBuildDay3: checkList?.cleanSurroundingBuildDay3 ? dayjs(checkList.cleanSurroundingBuildDay3) : null,
			// cleanSurroundingBuildDay4: checkList?.cleanSurroundingBuildDay4 ? dayjs(checkList.cleanSurroundingBuildDay4) : null,
			// cleanSurroundingBuildComment: checkList?.cleanSurroundingBuildComment,
			// dustCabinetsDate: checkList?.dustCabinetsDate ?  dayjs(checkList.dustCabinetsDate) : null,
			// dustCabinetsComment: checkList?.dustCabinetsComment ,
			// wasteBasketsDate: checkList?.wasteBasketsDate ?  dayjs(checkList.wasteBasketsDate) : null,
			// wasteBasketsComment: checkList?.wasteBasketsComment ,
			// movedFurnitureDate: checkList?.movedFurnitureDate ?  dayjs(checkList.movedFurnitureDate) : null,
			// movedFurnitureComment: checkList?.movedFurnitureComment,
			// vacuumFurnitureDate: checkList?.vacuumFurnitureDate ?  dayjs(checkList.vacuumFurnitureDate) : null,
			// vacuumFurnitureComment: checkList?.vacuumFurnitureComment,
			// windowBlindsDate: checkList?.windowBlindsDate ?  dayjs(checkList.windowBlindsDate) : null,
			// windowBlindsComment: checkList?.windowBlindsComment,
			// auxiliaryAreasDate: checkList?.auxiliaryAreasDate ?   dayjs(checkList.auxiliaryAreasDate) : null,
			// auxiliaryAreasComment: checkList?.auxiliaryAreasComment,
			// glassFacadesDate: checkList?.glassFacadesDate ?   dayjs(checkList.glassFacadesDate) : null,
			// glassFacadesComment:  checkList?.glassFacadesComment,
			// wipeRoofsDate: checkList?.wipeRoofsDate ?   dayjs(checkList.wipeRoofsDate) : null,
			// wipeRoofsComment:  checkList?.wipeRoofsComment,
			// multiStoreyDate: checkList?.multiStoreyDate ?   dayjs(checkList.multiStoreyDate) : null,
			// multiStoreyComment:  checkList?.multiStoreyComment,
			// securityShuttersDate: checkList?.securityShuttersDate ?   dayjs(checkList.securityShuttersDate) : null,
			// securityShuttersComment:  checkList?.securityShuttersComment,
			// officeCarpetsDate: checkList?.officeCarpetsDate ?   dayjs(checkList.officeCarpetsDate) : null,
			// officeCarpetsComment:  checkList?.officeCarpetsComment,
			// kitchenCabinetsDate: checkList?.kitchenCabinetsDate ?   dayjs(checkList.kitchenCabinetsDate) : null,
			// kitchenCabinetsComment:  checkList?.kitchenCabinetsComment,
			// externalMarbleDate: checkList?.externalMarbleDate ?   dayjs(checkList.externalMarbleDate) : null,
			// externalMarbleComment:  checkList?.externalMarbleComment,
			// marbleFloorsDate: checkList?.marbleFloorsDate ?   dayjs(checkList.marbleFloorsDate) : null,
			// marbleFloorsComment:  checkList?.marbleFloorsComment,
			// washGlassDate: checkList?.washGlassDate ?   dayjs(checkList.washGlassDate) : null,
			// washGlassComment:  checkList?.washGlassComment,
			// specialMultiStoreyDate: checkList?.specialMultiStoreyDate ?   dayjs(checkList.specialMultiStoreyDate) : null,
			// specialMultiStoreyComment:  checkList?.specialMultiStoreyComment,
			// washSecurityShuttersDate: checkList?.washSecurityShuttersDate ?   dayjs(checkList.washSecurityShuttersDate) : null,
			// washSecurityShuttersComment:  checkList?.washSecurityShuttersComment,
			// washOfficeCarpetsDate: checkList?.washOfficeCarpetsDate ?   dayjs(checkList.washOfficeCarpetsDate) : null,
			// washOfficeCarpetsComment:  checkList?.washOfficeCarpetsComment,
			// washSeatsDate: checkList?.washSeatsDate ?   dayjs(checkList.washSeatsDate) : null,
			// washSeatsComment:  checkList?.washSeatsComment,
			// mechanicalWashingDate: checkList?.mechanicalWashingDate ?   dayjs(checkList.mechanicalWashingDate) : null,
			// mechanicalWashingComment:  checkList?.mechanicalWashingComment,
			ucDailyTasks: checkList?.ucDailyTasks,
			ucDailyComment: checkList?.ucDailyComment,
			ucWeeklyTasks: checkList?.ucWeeklyTasks,
			ucWeeklyComment: checkList?.ucWeeklyComment,
			ucMonthlyTasks: checkList?.ucMonthlyTasks,
			ucMonthlyComment: checkList?.ucMonthlyComment ,
			ucTrimesterTasks: checkList?.ucTrimesterTasks ,
			ucTrimesterComment: checkList?.ucTrimesterComment,
			ucMonthlyTasks2: checkList?.ucMonthlyTasks2 ,
			ucMonthlyComment2: checkList?.ucMonthlyComment2 ,
			ucTrimesterTasks2: checkList?.ucTrimesterTasks2 ,
			ucTrimesterComment2: checkList?.ucTrimesterComment2 ,
			ucYearlyTask: checkList?.ucYearlyTask ,
			ucYearlyComment: checkList?.ucYearlyComment ,
			ucYearlyTask2: checkList?.ucYearlyTask2 ,
			ucYearlyComment2: checkList?.ucYearlyComment2 ,
			signName: checkList?.signName,
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	})
	
	
	//επειδή η φόρμα είναι μεγάλη και δεν θα φαίνονται τα κοκκινισμένα πεδία, βάλαμε και ενα snackbar επιπλέον για να δει πως έχει αφήσει πεδία ασυμπλήρωτα!
	useEffect(() => {
		if (formik.submitCount > 0 && Object.keys(formik.errors).length > 0) {
			enqueueSnackbar('Συμπληρώστε όλα τα υποχρεωτικά πεδία', {
				variant: 'error',
				autoHideDuration: 3000,
			});
		}
	}, [formik.submitCount, formik.errors]);
	
	return {
		formik,
		loadingSubmit
	}
}

export default useCheckListsForm